import React, { useState } from "react";
import moment from "moment";
import { AccountLayout } from "./accountUi";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { PageShell, FilterCard, ActionButton, TableCard, selectStyle, dateStyle, thStyle, tdStyle, EntriesHeader, Pager } from "./accountUi";

/* Profit & Loss — reference kingexch111.com/profit-loss.
 * Aggregates settled bets per sport into net P/L + commission. */

const SPORTS = [
  { name: "Cricket", eventType: 4 },
  { name: "Tennis", eventType: 2 },
  { name: "Soccer", eventType: 1 },
];

const ProfitLossNew = () => {
  const [from, setFrom] = useState(moment().subtract(1, "day").format("YYYY-MM-DD"));
  const [to, setTo] = useState(moment().format("YYYY-MM-DD"));
  const [limit, setLimit] = useState(10);
  const [rows, setRows] = useState([]);

  const netFromBets = (bets = []) => {
    let pl = 0;
    let commission = 0;
    bets.forEach((b) => {
      const won = b?.teamSelectionWin && b?.selectionId && String(b.teamSelectionWin) === String(b.selectionId);
      if (b?.type === "Yes" || b?.type === "No") {
        const yesWon = b?.decisionRun >= b?.betRun;
        const isWin = b?.type === "Yes" ? yesWon : !yesWon;
        pl += isWin ? parseFloat(b?.profitAmount || 0) : -parseFloat(b?.loseAmount || 0);
      } else if (b?.betType === "back") {
        pl += won ? parseFloat(b?.profitAmount || 0) : -parseFloat(b?.loseAmount || 0);
      } else if (b?.betType === "lay") {
        pl += !won ? parseFloat(b?.profitAmount || 0) : -parseFloat(b?.loseAmount || 0);
      }
      commission += parseFloat(b?.commission || 0);
    });
    return { pl: Math.round(pl * 100) / 100, commission: Math.round(commission * 100) / 100 };
  };

  const fetchData = async () => {
    const out = [];
    for (const s of SPORTS) {
      const collected = [];
      for (const betType of ["betfair", "sportBook", "fancy"]) {
        try {
          const { status, data } = await apiGet(apiPath.profitLoss, {
            betType,
            status: "completed",
            fromPeriod: from,
            toPeriod: to,
            eventType: s.eventType,
            page: 1,
            limit: 500,
          });
          if (status === 200 && data?.success) {
            const groups = Array.isArray(data?.results) ? data.results : data?.results?.data || [];
            groups.forEach((g) => (g?.bets_list || []).forEach((b) => collected.push(b)));
          }
        } catch (e) {
          /* ignore */
        }
      }
      if (collected.length > 0) {
        const { pl, commission } = netFromBets(collected);
        out.push({ sport: s.name, pl, commission });
      }
    }
    setRows(out);
  };

  return (
    <AccountLayout>
      <PageShell>
        <FilterCard>
          <select value="Data Source" disabled style={selectStyle}>
            <option>Data Source</option>
          </select>
          <input type="date" value={from} onChange={(e) => setFrom(e.target.value)} style={dateStyle} />
          <input type="date" value={to} onChange={(e) => setTo(e.target.value)} style={dateStyle} />
          <ActionButton onClick={fetchData}>Get P&amp;L</ActionButton>
        </FilterCard>

        <TableCard title="Profit/Loss">
          <EntriesHeader limit={limit} setLimit={setLimit} />
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={thStyle}>Sport Name</th>
                <th style={thStyle}>Profit/Loss</th>
                <th style={thStyle}>Commission</th>
              </tr>
            </thead>
            <tbody>
              {rows.length > 0 ? (
                rows.map((r) => (
                  <tr key={r.sport}>
                    <td style={{ ...tdStyle, color: "#2789ce", fontWeight: 600 }}>{r.sport}</td>
                    <td style={{ ...tdStyle, color: r.pl >= 0 ? "#1a7a1a" : "#c0392b", fontWeight: 600 }}>{r.pl}</td>
                    <td style={tdStyle}>{r.commission}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td style={tdStyle} colSpan={3}>
                    No data available in table
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <Pager showingText={`Showing ${rows.length === 0 ? 0 : 1} to ${rows.length} of ${rows.length} entries`} />
        </TableCard>
      </PageShell>
    </AccountLayout>
  );
};

export default ProfitLossNew;
